import { Injectable } from '@angular/core'
import { Message } from 'primeng/api'
import { Subject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class MessageService {
  private readonly messageSource = new Subject<Message[]>()
  messageObserver = this.messageSource.asObservable()
  private readonly clearSource = new Subject<string>()
  clearObserver = this.clearSource.asObservable()
  private readonly removeSource = new Subject<unknown>()
  removeObserver = this.removeSource.asObservable()

  add(message: Message) {
    if (message) {
      this.messageSource.next([message])
    }
  }

  addAll(messages: Message[]) {
    if (messages?.length) {
      this.messageSource.next(messages)
    }
  }

  clear(key?: string) {
    this.clearSource.next(key || null)
  }

  remove(id: unknown) {
    this.removeSource.next(id)
  }
}
